module.exports = "<ul *ngFor=\"let item of items\" class=\"collection\">\n  <li class=\"collection-item\">{{ item.name }}</li>  \n</ul>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/item/item.component.html
// module id = ./src/app/item/item.component.html
// module chunks = main